import React from 'react';
import { formatDate} from '../../utils/helpers';
import infoIcon from '../../assets/images/info-icon-outline.svg';
import warningIcon from '../../assets/images/warning-outline.svg';

import {
    easyAccessUrlSegment,
    fixedTermUrlSegment,
    noticeUrlSegment,
    productTypes
} from '../../utils/productHelpers';

/** @import {NewAccountData} from './newAccountsDataTypes' */

/** @type {NewAccountData[]} */
export const newAccountsData = [
    {
        productType: productTypes.EasyAccess,
        productName: 'The Online Flexi Saver',
        descriptionQualify: function (products, featureEnabled, rateChangeNotification, rateChanges) {
            return (<>
                <p>For a straightforward solution that gives you instant access to your money, our Online Flexi Saver account is a popular choice for its no-strings withdrawals to your linked account.</p>
                <p>&nbsp;</p>
                <p>Interest rate: {products[0].productAerRate ? `${products[0].productAerRate}% AER*` : `${products[0].productRate}% AER*`}</p>
                <p>&nbsp;</p>
                <p><strong>{featureEnabled('EnableInterimRateDecrease') && ((rateChanges != null && rateChanges.length === 2) ?
                    "Please note, the interest rate for this account will decrease from " + products[0].productAerRate + "% AER* / " + products[0].productRate + "% gross p.a. to "
                    // @ts-expect-error - cater for nulls
                    + (Math.round(rateChanges[1].aerRate * 100) / 100).toFixed(2) + "% AER* / " + (Math.round(rateChanges[1].rate * 100) / 100).toFixed(2) + "% gross p.a. effective " + formatDate(new Date(rateChanges[1].scheduledFor)) + ".\n The rate will further decrease to "
                    // @ts-expect-error - cater for nulls
                    + (Math.round(rateChanges[0].aerRate * 100) / 100).toFixed(2) + "% AER* / " + (Math.round(rateChanges[0].rate * 100) / 100).toFixed(2) + "% gross p.a. effective " + formatDate(new Date(rateChanges[0].scheduledFor)) + ".\n"
                    : ((rateChanges != null && rateChanges.length === 1) ?
                        "Please note, the interest rate for this account will decrease from " + products[0].productAerRate + "% AER* / " + products[0].productRate + "% gross p.a. to "
                        // @ts-expect-error - cater for nulls
                        + (Math.round(rateChanges[0].aerRate * 100) / 100).toFixed(2) + "% AER* / " + (Math.round(rateChanges[0].rate * 100) / 100).toFixed(2) + "% gross p.a. effective " + formatDate(new Date(rateChanges[0].scheduledFor)) + ".\n"
                        : ""))}
                    {!featureEnabled('EnableInterimRateDecrease') && (rateChangeNotification)}</strong></p>
            </>)
        },
        descriptionNotQualify: function (productRate, productAerRate, productData, featureEnabled, rateChangeNotification, rateChanges) {
            return (<>
                <p>We only offer one Online Flexi Saver per customer, but you can open as many Fixed Rate Savers and Notice Savers as you need.</p>
                <p>&nbsp;</p>
                <p>For a straightforward solution that gives you instant access to your money, our Online Flexi Saver account is a popular choice for its no-strings withdrawals to your linked account.</p>
                <p>&nbsp;</p>
                <p>Interest rate: {productAerRate ? <span>{productAerRate}% AER* / {productRate}% gross p.a.</span> : <span>{productRate} AER* / gross p.a.</span>}</p>
                <p>&nbsp;</p>
                <p><strong>
                    {featureEnabled('EnableInterimRateDecrease') && ((rateChanges != null && rateChanges.length === 2) ?
                        "Please note, the interest rate for this account will decrease from " + productAerRate + "% AER* / " + productRate + "% gross p.a. to "
                        // @ts-expect-error - cater for nulls
                        + (Math.round(rateChanges[1].aerRate * 100) / 100).toFixed(2) + "% AER* / " + (Math.round(rateChanges[1].rate * 100) / 100).toFixed(2) + "% gross p.a. effective " + formatDate(new Date(rateChanges[1].scheduledFor)) + ".\n The rate will further decrease to "
                        // @ts-expect-error - cater for nulls
                        + (Math.round(rateChanges[0].aerRate * 100) / 100).toFixed(2) + "% AER* / " + (Math.round(rateChanges[0].rate * 100) / 100).toFixed(2) + "% gross p.a. effective " + formatDate(new Date(rateChanges[0].scheduledFor)) + ".\n"
                        : ((rateChanges != null && rateChanges.length === 1) ?
                            "Please note, the interest rate for this account will decrease from " + productAerRate + "% AER* / " + productRate + "% gross p.a. to "
                            // @ts-expect-error - cater for nulls
                            + (Math.round(rateChanges[0].aerRate * 100) / 100).toFixed(2) + "% AER* / " + (Math.round(rateChanges[0].rate * 100) / 100).toFixed(2) + "% gross p.a. effective " + formatDate(new Date(rateChanges[0].scheduledFor)) + ".\n"
                            : ""))}
                    {!featureEnabled('EnableInterimRateDecrease') && (rateChangeNotification)}</strong></p>
            </>)
        },
        button: {
            label: 'Explore the Online Flexi Saver',
            click: `/new-account/${easyAccessUrlSegment()}`,
            dataAnalytics: "Explore OFS-SEC"
        }
    },
    {
        productType: productTypes.Notice,
        productName: 'The 90-Day Notice Saver',
        descriptionQualify: function (products, featureEnabled) {
            const product = products[0];
            return (<>
                <p>Offering a higher rate than our instant access account and the flexibility to access your savings in {product.productData.noticePeriod} {product.productData.noticePeriodUnit}, this account gives you the peace of mind that comes with knowing your money can be made available if you need it.</p>
                <p>&nbsp;</p>
                <p>In return for a notice period before you access your money, our 90-Day Notice Saver balances higher rates than an instant access account with more flexibility than a fixed term.</p>
                <p>&nbsp;</p>
                <p>Interest rate: {product.productAerRate ? <span>{product.productAerRate}% AER* / {product.productRate}% gross p.a.</span> : <span>{product.productRate} AER* / gross p.a.</span>}</p>
            </>)
        },
        descriptionNotQualify: function (productRate, productAerRate, productData, featureEnabled) { return null; },
        button: {
            label: 'Explore the 90-Day Notice Saver',
            click: `/new-account/${noticeUrlSegment()}`,
            dataAnalytics: "Explore NS-SEC"
        }
    },
    {
        productType: productTypes.FixedTerm,
        productName: 'The Fixed Rate Saver',
        descriptionQualify: function (products, featureEnabled) {
            return (<>
                <p>If you're looking to make your money work a little harder, you can earn higher rates with our Fixed Rate Saver by depositing your money for a fixed term.</p>
                <p>&nbsp;</p>
                <div className="frs-products-container">
                    {products.map((p, index) => (
                        <div key={p.productCode || index} className="frs-product-layout">
                            <h3 className="frs-product-name">
                                {p.productName}
                            </h3>
                            <p className="frs-product-rate">
                                <strong>Annual interest: {p.productAerRate || p.productRate}</strong>% AER* / gross p.a.
                            </p>
                        </div>
                    ))}
                </div>
            </>)
        },
        descriptionNotQualify: function (productRate, productAerRate, productData, featureEnabled) { return null; },
        button: {
            label: 'Explore the Fixed Rate Saver',
            click: `/new-account/${fixedTermUrlSegment()}`,
            dataAnalytics: "Explore FRS-SEC"
        }
    },
    {
        productType: productTypes.FixedRateCashISA,
        productName: 'The Fixed Rate Cash ISA',
        descriptionQualify: function (products, featureEnabled, _rateChangeNotification, _rateChanges, isaLimitBreached) {
            const product = products && products.length > 0 ? products[0] : null;

            return (<>
                <div className="fisa-qualify-header">
                    <div className="fisa-qualify-description">
                        <p>Looking for a simple way to grow your savings tax-free? Our Fixed Rate Cash ISA offers a guaranteed return when you lock your money away for a set term.</p>
                        <p>Save up to £20,000 a year and earn tax-free interest as part of your UK ISA allowance.</p>
                    </div>
                    <div className="fisa-transfer-info">
                        <p><strong>Have a Cash ISA with another provider?</strong><br />Choose to transfer to Investec Save when opening an account and leave the rest to us.</p>
                    </div>
                </div>
                {product && (
                    <div className="fisa-product-layout">
                        <h3 className="fisa-product-name">
                            {product.productName}
                        </h3>
                        <p className="fisa-product-rate">
                            <strong>Annual interest: {product.productAerRate || product.productRate}</strong>% AER* / gross p.a.
                        </p>
                    </div>
                )}
                {isaLimitBreached && (
                    <div className="fisa-warning-message">
                        <div className="fisa-warning-content">
                            <img alt="" className="fisa-warning-icon" src={warningIcon} aria-hidden="true" />
                            <div className="fisa-warning-text">
                                <p>You can save up to £20,000 this tax year</p>
                                <p>This is the current UK government ISA allowance. We&apos;ll return any ISA contributions that would see you exceed this amount.</p>
                            </div>
                        </div>
                    </div>
                )}
            </>);
        },
        descriptionNotQualify: function (productRate, productAerRate, _productData, _featureEnabled) { 
            return (<>
                <p>Looking for a simple way to grow your savings tax-free? Our Fixed Rate Cash ISA offers a guaranteed return when you lock your money away for a set term.</p>
                <p>&nbsp;</p>
                <p>Earn tax-free interest up to your annual ISA allowance and enjoy the certainty of a fixed return.</p>
                <p>&nbsp;</p>
                <div className="fisa-product-layout">
                    <h3 className="fisa-product-name">
                        1-Year Fixed Rate Cash ISA
                    </h3>
                    <p className="fisa-product-rate">
                        <strong>Annual interest: {productAerRate || productRate}</strong>% AER* / gross p.a.
                    </p>
                </div>
                <div className="fisa-info-message">
                    <div className="fisa-info-content">
                        <img alt="info" className="fisa-info-icon" src={infoIcon}/>
                        <div className="fisa-info-text">
                            <p>You can&apos;t open another Fixed Rate Cash ISA</p>
                            <p>You&apos;ve already used over £19,000.01 of your ISA allowance this tax year. Our Fixed Rate Cash ISA requires a minimum deposit of £1,000.00, which means you don&apos;t have enough remaining allowance to open another one this current tax year.</p>
                        </div>
                    </div>
                </div>
            </>)
        },
        button: {
            label: 'Explore the Fixed Rate Cash ISA',
            click: '/new-account/fisa',
            dataAnalytics: "Explore FISA-SEC"
        }
    }
];